export default __webpack_public_path__ + "static/media/jordan_2.2ba0bf2c.png";